export default [
  {
    key: 'branchOfficeName',
    label: '支店名',
    style: {
    }
  }, 
  {
    key: 'name',
    label: '部署名',
    style: {
    }
  }, 
  {
    key: 'code',
    label: '部署コード',
    style: {
    }
  },
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/department/listHeader.js